'use client'
import {
  ControlledButtonSubmit,
  ControlledCitySelector,
  ControlledForm,
  ControlledRange,
  ControlledSelectDropdown
} from "@/components/molecules/form";
import {serialize} from "@/lib/tools/strings";
import {useRouter} from "next/navigation";
import {PropsWithChildren} from "react";
import {useForm} from "react-hook-form";
import {Item, ServiceSearchRequest} from "@/lib/types";


interface Props extends PropsWithChildren<any> {
  types: Item[],
  pets: Item[],
  filters: ServiceSearchRequest
}

function getDefaultValues(initial: { [key: string]: any }, defaultValues: { [key: string]: any }): Partial<{
  [key: string]: any
}> {
  const merged = Object.assign({}, defaultValues, initial)
  // if(merged.city_code && typeof  merged.city_code == "object"){
  //   merged.city_code.value = {...merged.city_code}
  //   merged.city_code.label = merged.city.name
  // }

  return merged
}

export default function ListingsFilters(props: Props) {
  const router = useRouter()


  const petOptions = props.pets.map((c: Item) => ({label: c.name, value: c.value}))
  const lodgingOptions = props.types.map((c: Item) => ({label: c.name, value: c.value}))
  // const equipmentOptions = props.equipments.map((c: Item) => ({label: c.value, value: c.name}))

  const form = useForm<any>({
    defaultValues: getDefaultValues(props.filters, {
      distance: 1,
      pet_count: 1,
      persons: 2,
    })
  })

  const handleSubmit = (data: any) => {
    // transform data
    const form: ServiceSearchRequest = {
      // TODO
      keyword: data.keyword,

      //TODO as List
      location_codes: data.city.value?.id + '',
      location_type: "city_id",
      location_distance: data.distance,
      // number_pets: data.pet_count,

      //TODO not supported yet!
      // lower_price: data.lower_price,
      // higher_price: data.higher_price,
      // number_adults: data.persons,
      entity_types: data.types,
      pet_types: data.pets,
      // entity_attributes: data.equipments,
    }

    router.push('/services?' + serialize(form))
    router.refresh()
  }

  return <div>
    <ControlledForm useForm={form} onSubmit={form.handleSubmit(handleSubmit)}>
      <div className="grid grid-flow-row lg:grid-flow-col">
        {/*<ControlledRange useForm={form} label={"Nombre de personnes"} name={"persons"} min={1} max={12} step={1}*/}
        {/*                 renderValue={(v) => v + ''}/>*/}
        {/*<ControlledRange useForm={form} label={"Nombre d'animaux"} name={"pet_count"} min={1} max={6} step={1}*/}
        {/*                 renderValue={(v) => v + ''}/>*/}
        <ControlledSelectDropdown useForm={form} label={"Types de service"} optionLabel="label"
                                  options={lodgingOptions} name={"entity_types"}/>

        <ControlledSelectDropdown useForm={form} label={"Types d'animaux"} optionLabel="label"
                                  options={petOptions} name={"pet_types"}/>
        {/*</div>*/}
        {/*<SDivider center={true}/>*/}
        {/*<div className="grid grid-flow-row lg:grid-flow-col">*/}

        {/*  <div className="flex flex-row">*/}
        {/*    /!*<ControlledInputText useForm={form} label={"Prix min"} name={"lower_price"} className={"md:w-24"}/>*!/*/}
        {/*    /!*<ControlledInputText useForm={form} label={"Prix max"} name={"higher_price"} className={"md:w-24"}/>*!/*/}
        {/*  </div>*/}


        {/*<ControlledSelectDropdown useForm={form} label={"Equipements"} optionLabel="label"*/}
        {/*                          options={equipmentOptions} name={"equipments"}/>*/}
      </div>

      <div className="grid grid-flow-row lg:grid-flow-col">
        {/*<ControlledInputText useForm={form} label={"Que recherchez-vous?"} placeholder={'titre, lieu, nom...'}*/}
        {/*                     name={"keyword"}/>*/}
        <ControlledCitySelector useForm={form} label={"Ville"} name={"city_id"} required={true}/>
        <ControlledRange useForm={form} label={"Rayon de recherche"} name={"distance"} min={25} max={250} step={10}
                         renderValue={(v) => v + ' km'}/>
      </div>
      {/*<SDivider center={true}/>*/}


      <ControlledButtonSubmit useForm={form}
                              label={"Mettre à jour"}/>

    </ControlledForm>
  </div>
}
